import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { BackgroundFade } from './styled';
export var ConditionalFadeOut = function ConditionalFadeOut(_ref) {
  var testId = _ref.testId,
    _ref$shouldFadeOut = _ref.shouldFadeOut,
    shouldFadeOut = _ref$shouldFadeOut === void 0 ? false : _ref$shouldFadeOut,
    children = _ref.children,
    className = _ref.className,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 3000 : _ref$delay;
  var _useState = useState(shouldFadeOut),
    _useState2 = _slicedToArray(_useState, 2),
    showBackground = _useState2[0],
    setShowBackground = _useState2[1];
  useEffect(function () {
    var timer;

    // Only remove the background when shouldFadeOut goes from `true` -> `false`
    if (showBackground && !shouldFadeOut) {
      timer = setTimeout(function () {
        return setShowBackground(false);
      }, delay);
    }
    return function () {
      return clearTimeout(timer);
    };
  }, [showBackground, shouldFadeOut, delay]);
  return /*#__PURE__*/React.createElement(BackgroundFade, {
    "data-testid": testId,
    isUnseen: Boolean(showBackground)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: className
  }, children);
};